"use client"

import { useState, useEffect } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { 
  faGraduationCap, 
  faBriefcase, 
  faBuilding, 
  faHammer,  
  faStar,
  faCheckCircle,
  faShieldAlt,
  faRocket,
  faTrophy,
  faHeart,
  faTag,
  faGift,
  faPhone,
  faTimes,
  faPercent,
  faCheck,
  faCrown,
  faGavel,
  faClock,
  faUsers,
  faHardHat
} from "@fortawesome/free-solid-svg-icons"
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons"
import api from "../../../services/axiosInstance"
import { FaTools } from "react-icons/fa"



// Style configuration
export const STYLE_CONFIG = {
  students: {
    gradient: "from-emerald-600 via-emerald-700 to-emerald-800",
    bgPattern: "bg-emerald-50",
    accentColor: "emerald",
    mainIcon: faGraduationCap,
    iconBg: "bg-emerald-100",
    textColor: "text-emerald-600",
  },
  professionals: {
    gradient: "from-emerald-500 via-green-600 to-teal-700",
    bgPattern: "bg-green-50",
    accentColor: "green",
    mainIcon: faBriefcase,
    iconBg: "bg-green-100",
    textColor: "text-green-600",
  },
  construction: {
    gradient: "from-orange-500 via-red-500 to-pink-600",
    bgPattern: "bg-orange-50",
    accentColor: "orange",
    mainIcon: faHammer,
    iconBg: "bg-orange-100",
    textColor: "text-orange-600",
  },
};



export default function ServicesSection() {
  const [selectedService, setSelectedService] = useState(null)
  const [servicesData, setServicesData] = useState(null)
  const [mounted, setMounted] = useState(false)

const [loading, setLoading] = useState(true);
const [error, setError] = useState(false);

// Map of icon names to imported icons
const cardHighlightIcons = {
  students: [faPercent, faClock], // only 2 icons for students
  professionals: [faRocket, faUsers], // faUsers from FontAwesome
  construction: [faHammer, faHardHat], // placeholder for midouwar & khoudha
};

const packIcons = [faRocket, faCrown, faStar]; // static icons for first 3 packs


useEffect(() => {
  setMounted(true);

  const fetchServices = async () => {
    try {
      const res = await api.get("/services");
      const data = res.data;

      if (
        !data ||
        typeof data !== "object" ||
        !data.students ||
        !data.professionals ||
        !data.construction
      ) {
        throw new Error("Services data not ready");
      }

      setServicesData(data);
    } catch (err) {
      console.error("Services fetch failed:", err);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  fetchServices();
}, []);



  const serviceIds = servicesData ? Object.keys(servicesData) : [];

  const contactWhatsApp = (packName) => {
    const phoneNumber = "+213549075577"
    const message = `Bonjour ! Je suis intéressé(e) par le ${packName}. Pouvez-vous me donner plus d'informations ?`
    const whatsappUrl = `https://wa.me/${phoneNumber.replace("+", "")}?text=${encodeURIComponent(message)}`
    window.open(whatsappUrl, "_blank", "noopener,noreferrer")
  }

  const contactForService = (serviceId) => {
    const phoneNumber = "+213549075577"
    const message = `Bonjour, j’aimerais consulter un expert`
    const whatsappUrl = `https://wa.me/${phoneNumber.replace("+", "")}?text=${encodeURIComponent(message)}`
    window.open(whatsappUrl, "_blank", "noopener,noreferrer")
  }

 if (!mounted) return null;

if (loading) {
  return (
    <section className="py-20 flex justify-center items-center">
      <div className="flex flex-col items-center space-y-4">
        <div className="w-12 h-12 border-4 border-gray-300 border-t-transparent rounded-full animate-spin"></div>
        <p className="text-gray-600 font-medium">Chargement des services...</p>
      </div>
    </section>
  );
}

if (error) {
  return (
    <section className="py-20 text-center">
      <p className="text-red-600 font-semibold">
        Impossible de charger les services. Veuillez réessayer plus tard.
      </p>
    </section>
  );
}

if (!servicesData) return null;

  return (
    <section id="services" className=" bg-gray-50 ">
      <section id="services" className="py-20 bg-gray-50 to-white">
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    {/* Header */}
    <div className="text-center mb-16">
      <div className="flex items-center justify-center gap-4 mb-2">
        <h1 className="text-4xl font-bold text-gray-800">Nos Services</h1>
      </div>
      <p className="text-gray-500">
        Des solutions adaptées à chaque profil, conçues pour répondre à vos besoins spécifiques
      </p>
    </div>

    {/* Service Cards Grid - 4 columns on desktop */}
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto mb-16">
      {serviceIds.map((serviceId) => {
        const service = servicesData[serviceId]
        const style = STYLE_CONFIG[serviceId]

        return (
          <button
            key={serviceId}
            onClick={() => setSelectedService(serviceId)}
            className="group relative overflow-hidden rounded-2xl bg-gray-50 border border-gray-200 shadow-sm hover:shadow-md transition-all duration-300 text-left h-full hover:border-[#2fb383] focus:outline-none focus:ring-2 focus:ring-[#2fb383] focus:ring-opacity-30"
          >
            {/* Subtle animated background */}
            <div className="absolute inset-0 bg-gradient-to-br from-[#2fb383]/10 to-white opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            
            {/* Minimal accent line */}
            <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-[#2fb383] to-[#269c6f] transform origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-300" />

            <div className="relative p-6 min-h-[320px] flex flex-col justify-between z-10">
              {/* Icon & Title */}
              <div className="text-center">
                <div className="w-16 h-16 rounded-full bg-[#2fb383]/10 flex items-center justify-center mx-auto mb-4 shadow-sm transition-all duration-300 group-hover:scale-110 group-hover:shadow-md">
                  <FontAwesomeIcon 
                    icon={style.mainIcon} 
                    className="text-2xl text-[#2fb383] transition-all duration-300 group-hover:text-[#269c6f]"
                  />
                </div>

                <h3 className="text-xl font-semibold mb-3 text-gray-800 group-hover:text-[#2fb383] transition-colors duration-200">
                  {service.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {service.description}
                </p>
              </div>

              {/* Features Preview */}
              <div className="space-y-2.5 mt-4">
                {service.highlights?.map((feature, idx) => (
                  <div 
                    key={idx} 
                    className="flex items-center space-x-3 px-2 py-1.5 rounded-lg transition-all duration-200 group-hover:bg-[#2fb383]/10"
                  >
                    <div className="w-6 h-6 rounded-full bg-[#2fb383]/20 flex items-center justify-center flex-shrink-0">
                      <FontAwesomeIcon 
                        icon={cardHighlightIcons[serviceId][idx % cardHighlightIcons[serviceId].length]} 
                        className="text-xs text-[#2fb383]" 
                      />
                    </div>
                    <span className="font-medium text-sm text-gray-700 text-left">
                      {feature}
                    </span>
                  </div>
                ))}
              </div>

              {/* Price & CTA */}
              <div className="text-center mt-6 pt-4 border-t border-gray-100">
                <div className="flex items-center justify-center space-x-2">
                  <span className="text-lg font-bold text-[#2fb383]">
                    {service.startingPrice || service.packs?.[0]?.price || 'Prix sur demande'}
                  </span>
                  <FontAwesomeIcon 
                    icon="fa-solid fa-arrow-right" 
                    className="text-[#2fb383] opacity-0 transform -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300"
                  />
                </div>
                <span className="inline-block mt-2 text-xs text-[#2fb383] font-medium opacity-0 opacity-100 transition-opacity duration-300">
                  Cliquez pour en savoir plus
                </span>
              </div>
            </div>
          </button>
        )
      })}
    </div>

    {/* Global CTA - Keep the existing green button at bottom */}
    <div className="text-center mt-12">
      <p className="text-gray-600 mb-6">
        Vous ne trouvez pas ce que vous cherchez ? Contactez-nous pour une solution personnalisée.
      </p>
      <button
        onClick={() => contactForService('students')}
        className="bg-gradient-to-r from-[#2fb383] to-emerald-600 text-white px-8 py-4 rounded-xl font-bold text-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 inline-flex items-center"
      >
        <FontAwesomeIcon icon={faWhatsapp} className="mr-3 text-xl" />
        Discuter avec un expert
      </button>
    </div>
  </div>
</section>
     <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
  {/* Detailed View Modal */}
  {selectedService && servicesData?.[selectedService] && (
    <div onClick={() => setSelectedService(null)} className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-2 sm:p-4">
      <div
        className="relative w-full max-w-6xl h-[95vh] sm:h-[90vh] bg-white rounded-xl sm:rounded-2xl overflow-hidden flex flex-col md:flex-row"
        onClick={(e) => e.stopPropagation()}
      >
        {/* CLOSE BUTTON */}
        <button
          onClick={() => setSelectedService(null)}
          className="absolute top-2 right-2 sm:top-4 sm:right-4 z-20 w-8 h-8 sm:w-10 sm:h-10 rounded-full border border-gray-200 bg-white flex items-center justify-center hover:bg-gray-100 transition"
        >
          <FontAwesomeIcon icon={faTimes} className="text-sm sm:text-base" />
        </button>

        {/* LEFT SIDEBAR */}
        <aside className="w-full md:w-[35%] lg:w-[30%] bg-emerald-900 text-white p-4 sm:p-6 md:p-8 flex flex-col justify-between">
          <div>
            <div className="w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 border border-white/20 rounded-lg md:rounded-xl flex items-center justify-center mb-4 sm:mb-6">
              <FontAwesomeIcon
                icon={STYLE_CONFIG[selectedService].mainIcon}
                className="text-xl sm:text-2xl"
              />
            </div>

            <h2 className="text-2xl sm:text-3xl font-bold mb-3 sm:mb-4">
              {servicesData[selectedService].title}
            </h2>

            <p className="text-white/70 leading-relaxed text-sm sm:text-base">
              {servicesData[selectedService].description}
            </p>
          </div>

          <button
            onClick={() => contactForService(selectedService)}
            className="mt-6 sm:mt-8 bg-white text-gray-900 py-2.5 sm:py-3 rounded-lg font-bold hover:bg-gray-100 transition text-sm sm:text-base"
          >
            Consultation gratuite
          </button>
        </aside>

        {/* MAIN CONTENT */}
        <main className="flex-1 overflow-y-auto p-4 sm:p-6 md:p-8 space-y-6 sm:space-y-8 md:space-y-12">
          {/* FEATURES */}
          <section>
  <h3 className="text-lg sm:text-xl font-bold mb-4 sm:mb-6">Avantages clés</h3>

  <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
    {servicesData[selectedService].services
      .filter(feature => feature && feature.trim() !== '') // Filter out empty strings
      .map((feature, i) => (
        <li
          key={i}
          className="flex items-start gap-2 sm:gap-3 border border-gray-200 rounded-lg p-3 sm:p-4"
        >
          <FontAwesomeIcon 
            icon={faCheckCircle} 
            className="mt-0.5 sm:mt-1 text-gray-900 text-sm sm:text-base" 
          />
          <span className="text-gray-700 text-sm sm:text-base">{feature}</span>
        </li>
      ))
    }
  </ul>
</section> 

          {/* PRICING */}
          <section className="border border-gray-200 rounded-xl p-4 sm:p-6">
            <h3 className="text-base sm:text-lg font-bold mb-2">Tarification</h3>
            <p className="text-gray-600 mb-3 sm:mb-4 text-sm sm:text-base">
              {servicesData[selectedService].pricing}
            </p>

            <button
              onClick={() => contactForService(selectedService)}
              className="w-full sm:w-auto border border-gray-900 px-4 sm:px-6 py-2.5 sm:py-3 rounded-lg font-semibold hover:bg-gray-900 hover:text-white transition text-sm sm:text-base"
            >
              Demander un devis
            </button>
          </section>

          {/* PACKS */}
         <section>
  <h3 className="text-xl sm:text-2xl font-bold mb-4 sm:mb-6 md:mb-8">
    Packs disponibles
  </h3>

  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
    {servicesData[selectedService].packs
      .filter(pack =>
        pack &&
        pack.name?.trim() &&
        (pack.price?.trim() || pack.features?.length)
      )
      .map((pack, idx) => {
        const validFeatures = (pack.features || []).filter(
          f => f && f.trim() !== ""
        );

        return (
          <div
            key={idx}
            className="border border-gray-200 rounded-xl p-4 sm:p-6 flex flex-col"
          >
            {/* NAME */}
            {pack.name && (
              <h4 className="font-bold text-base sm:text-lg mb-2">
                {pack.name}
              </h4>
            )}

            {/* DESCRIPTION */}
            {pack.description?.trim() && (
              <p className="text-gray-600 text-xs sm:text-sm mb-3 sm:mb-4">
                {pack.description}
              </p>
            )}

            {/* PRICE */}
            {pack.price?.trim() && (
              <div className="text-xl sm:text-2xl font-bold mb-3 sm:mb-4">
                {pack.price}
              </div>
            )}

            {/* FEATURES */}
            {validFeatures.length > 0 && (
              <ul className="space-y-1.5 sm:space-y-2 mb-4 sm:mb-6">
                {validFeatures.map((feature, i) => (
                  <li
                    key={i}
                    className="flex items-center gap-2 text-xs sm:text-sm text-gray-700"
                  >
                    <FontAwesomeIcon icon={faCheck} className="text-xs" />
                    {feature}
                  </li>
                ))}
              </ul>
            )}

            {/* CTA */}
            <button
              onClick={() => contactWhatsApp(pack.name)}
              className="mt-auto bg-gray-900 text-white py-2.5 sm:py-3 rounded-lg hover:bg-black transition text-sm sm:text-base"
            >
              Choisir ce pack
            </button>
          </div>
        );
      })}
  </div>
</section>
 

          {/* FOOTER ACTIONS - Mobile Stacked, Desktop Horizontal */}
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 pt-6 sm:pt-8 border-t">
            <button
              onClick={() => contactForService(selectedService)}
              className="flex-1 bg-gray-900 text-white py-3 sm:py-4 rounded-lg font-bold text-sm sm:text-base"
            >
              Consultation gratuite
            </button>
            <button
              onClick={() => setSelectedService(null)}
              className="flex-1 border border-gray-300 py-3 sm:py-4 rounded-lg font-bold text-sm sm:text-base"
            >
              Fermer
            </button>
          </div>
        </main>
      </div>
    </div>
  )}
</div>
      {/* Add custom animations */}
      <style jsx>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        
        @keyframes slideUp {
          from { 
            opacity: 0;
            transform: translateY(20px);
          }
          to { 
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .animate-fadeIn {
          animation: fadeIn 0.3s ease-out;
        }
        
        .animate-slideUp {
          animation: slideUp 0.4s ease-out;
        }
      `}</style>
    </section>
  )
}
 
// import React, { useState } from 'react';
// import { 
//   FaGraduationCap, 
//   FaBriefcase, 
//   FaHammer, 
//   FaPercentage, 
//   FaClock, 
//   FaRocket, 
//   FaUsers, 
//   FaDraftingCompass, 
//   FaHardHat, 
//   FaCogs
// } from 'react-icons/fa';

// const Services = () => {
//   const [selectedService, setSelectedService] = useState(null);

//   const services = [
//     {
//       id: 'students',
//       title: 'ÉTUDIANTS',
//       subtitle: 'Formation académique',
//       price: 'À partir de 9,000 DA',
//       gradient: 'from-blue-500 via-blue-600 to-indigo-700',
//       icon: <FaGraduationCap className="text-2xl" />,
//       features: [
//         { icon: <FaPercentage className="text-lg" />, text: '-30% RÉDUCTION' },
//         { icon: <FaClock className="text-lg" />, text: 'HORAIRES FLEXIBLES' }
//       ]
//     },
//     {
//       id: 'professionals',
//       title: 'PROFESSIONNELS',
//       subtitle: 'Perfectionnement',
//       price: 'À partir de 35,000 DA',
//       gradient: 'from-emerald-500 via-green-600 to-teal-700',
//       icon: <FaBriefcase className="text-2xl" />,
//       features: [
//         { icon: <FaRocket className="text-lg" />, text: 'FORMATION INTENSIVE' },
//         { icon: <FaUsers className="text-lg" />, text: 'CONSULTING' }
//       ]
//     },
//     {
//       id: 'construction',
//       title: 'CONSTRUCTION',
//       subtitle: 'Projets privés',
//       price: 'À partir de 50,000 DA',
//       gradient: 'from-orange-500 via-red-500 to-pink-600',
//       icon: <FaHammer className="text-2xl" />,
//       features: [
//         { icon: <FaDraftingCompass className="text-lg" />, text: 'CONCEPTION' },
//         { icon: <FaHardHat className="text-lg" />, text: 'SUIVI CHANTIER' }
//       ]
//     }
//   ];

//   const showServiceDetails = (serviceId) => {
//     setSelectedService(serviceId);
//     // You can add modal logic here if needed
//     alert(`Détails du service: ${serviceId}`);
//   };

//   return (
//     <section id="services" className="py-20 bg-gray-50">
//       <div className="max-w-7xl mx-auto px-4">
//        <div className="text-center mb-16">
//   <div className="flex items-center justify-center gap-4 mb-4">
//     <FaCogs className="text-4xl text-blue-800" />
//     <h2 className="text-4xl font-bold text-gray-800">Nos Services</h2>
//   </div>
//   <p className="text-xl text-gray-600">Solutions adaptées à chaque profil</p>
// </div>

//         <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto">
//           {services.map((service) => (
//             <div 
//               key={service.id}
//               className="relative overflow-hidden rounded-2xl shadow-lg cursor-pointer transform hover:scale-105 transition-all duration-300 group"
//               onClick={() => showServiceDetails(service.id)}
//             >
//               <div className={`absolute inset-0 bg-gradient-to-br ${service.gradient}`}></div>
//               <div className="relative p-6 text-white min-h-[250px] flex flex-col justify-between">
//                 <div className="text-center">
//                   <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4 backdrop-blur-sm group-hover:bg-white/30 transition-all">
//                     {service.icon}
//                   </div>
//                   <h3 className="text-2xl font-bold mb-2">{service.title}</h3>
//                   <p className={
//                     service.id === 'students' ? 'text-blue-100' :
//                     service.id === 'professionals' ? 'text-green-100' :
//                     'text-orange-100'
//                   }>
//                     {service.subtitle}
//                   </p>
//                 </div>
                
//                 <div className="space-y-3 mt-4">
//                   {service.features.map((feature, index) => (
//                     <div key={index} className="flex items-center justify-center space-x-2">
//                       {feature.icon}
//                       <span className="font-bold">{feature.text}</span>
//                     </div>
//                   ))}
//                 </div>
                
//                 <div className="text-center mt-4 pt-4 border-t border-white/20">
//                   <span className="text-xl font-bold">{service.price}</span>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* Enhanced Background Styles */}
//       <style jsx>{`
//         body {
//           box-sizing: border-box;
//         }
        
//         .dynamic-bg {
//           background: linear-gradient(135deg, rgba(30, 64, 175, 0.95) 0%, rgba(59, 130, 246, 0.90) 50%, rgba(37, 99, 235, 0.95) 100%);
//           position: relative;
//           overflow: hidden;
//         }
        
//         .dynamic-bg::before {
//           content: '';
//           position: absolute;
//           top: 0;
//           left: 0;
//           right: 0;
//           bottom: 0;
//           background: 
//             radial-gradient(circle at 20% 30%, rgba(59, 130, 246, 0.25) 0%, transparent 60%),
//             radial-gradient(circle at 80% 70%, rgba(37, 99, 235, 0.20) 0%, transparent 55%),
//             radial-gradient(circle at 40% 80%, rgba(96, 165, 250, 0.15) 0%, transparent 50%),
//             radial-gradient(circle at 60% 20%, rgba(147, 197, 253, 0.10) 0%, transparent 45%),
//             linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.08) 50%, transparent 70%);
//           animation: backgroundShift 25s ease-in-out infinite;
//         }
        
//         @keyframes backgroundShift {
//           0%, 100% { 
//             background: 
//               radial-gradient(circle at 20% 30%, rgba(59, 130, 246, 0.25) 0%, transparent 60%),
//               radial-gradient(circle at 80% 70%, rgba(37, 99, 235, 0.20) 0%, transparent 55%),
//               radial-gradient(circle at 40% 80%, rgba(96, 165, 250, 0.15) 0%, transparent 50%),
//               radial-gradient(circle at 60% 20%, rgba(147, 197, 253, 0.10) 0%, transparent 45%);
//           }
//           25% { 
//             background: 
//               radial-gradient(circle at 70% 20%, rgba(59, 130, 246, 0.30) 0%, transparent 65%),
//               radial-gradient(circle at 30% 80%, rgba(37, 99, 235, 0.25) 0%, transparent 60%),
//               radial-gradient(circle at 90% 40%, rgba(96, 165, 250, 0.20) 0%, transparent 55%),
//               radial-gradient(circle at 10% 60%, rgba(147, 197, 253, 0.15) 0%, transparent 50%);
//           }
//           50% { 
//             background: 
//               radial-gradient(circle at 50% 90%, rgba(59, 130, 246, 0.20) 0%, transparent 55%),
//               radial-gradient(circle at 10% 30%, rgba(37, 99, 235, 0.30) 0%, transparent 65%),
//               radial-gradient(circle at 80% 10%, rgba(96, 165, 250, 0.25) 0%, transparent 60%),
//               radial-gradient(circle at 40% 50%, rgba(147, 197, 253, 0.12) 0%, transparent 48%);
//           }
//           75% { 
//             background: 
//               radial-gradient(circle at 30% 40%, rgba(59, 130, 246, 0.28) 0%, transparent 62%),
//               radial-gradient(circle at 90% 20%, rgba(37, 99, 235, 0.18) 0%, transparent 52%),
//               radial-gradient(circle at 20% 90%, rgba(96, 165, 250, 0.22) 0%, transparent 58%),
//               radial-gradient(circle at 70% 70%, rgba(147, 197, 253, 0.14) 0%, transparent 47%);
//           }
//         }
        
//         .floating-letters {
//           position: absolute;
//           font-size: 6rem;
//           font-weight: bold;
//           color: rgba(255, 255, 255, 0.4);
//           animation: floatAdvanced 12s ease-in-out infinite;
//           user-select: none;
//           pointer-events: none;
//           text-shadow: 0 0 20px rgba(255, 255, 255, 0.3);
//         }
        
//         .floating-shapes {
//           position: absolute;
//           animation: floatShapes 15s ease-in-out infinite;
//         }
        
//         @keyframes floatAdvanced {
//           0% { 
//             transform: translateY(0px) translateX(0px) rotate(0deg) scale(1); 
//             opacity: 0.3; 
//           }
//           15% { 
//             transform: translateY(-40px) translateX(20px) rotate(8deg) scale(1.1); 
//             opacity: 0.5; 
//           }
//           30% { 
//             transform: translateY(-20px) translateX(-15px) rotate(-5deg) scale(0.9); 
//             opacity: 0.4; 
//           }
//           45% { 
//             transform: translateY(-60px) translateX(30px) rotate(12deg) scale(1.2); 
//             opacity: 0.6; 
//           }
//           60% { 
//             transform: translateY(-10px) translateX(-25px) rotate(-8deg) scale(0.8); 
//             opacity: 0.35; 
//           }
//           75% { 
//             transform: translateY(-45px) translateX(15px) rotate(6deg) scale(1.05); 
//             opacity: 0.55; 
//           }
//           90% { 
//             transform: translateY(-25px) translateX(-10px) rotate(-3deg) scale(0.95); 
//             opacity: 0.4; 
//           }
//           100% { 
//             transform: translateY(0px) translateX(0px) rotate(0deg) scale(1); 
//             opacity: 0.3; 
//           }
//         }
        
//         @keyframes floatShapes {
//           0%, 100% { transform: translateY(0px) scale(1) rotate(0deg); }
//           50% { transform: translateY(-40px) scale(1.1) rotate(180deg); }
//         }
        
//         .modal {
//           display: none;
//           position: fixed;
//           z-index: 99999;
//           left: 0;
//           top: 0;
//           width: 100%;
//           height: 100%;
//           background: rgba(0, 0, 0, 0.85);
//           backdrop-filter: blur(15px);
//         }
        
//         .modal-content {
//           background: white;
//           backdrop-filter: blur(20px);
//           margin: 2% auto;
//           padding: 0;
//           border-radius: 25px;
//           width: 90%;
//           max-width: 900px;
//           max-height: 90vh;
//           overflow-y: auto;
//           animation: modalSlideIn 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
//           border: 1px solid rgba(255, 255, 255, 0.3);
//           box-shadow: 0 25px 50px rgba(0, 0, 0, 0.6);
//           position: relative;
//           z-index: 100000;
//         }
        
//         @keyframes modalSlideIn {
//           from { 
//             opacity: 0; 
//             transform: translateY(-100px) scale(0.8); 
//             filter: blur(10px);
//           }
//           to { 
//             opacity: 1; 
//             transform: translateY(0) scale(1); 
//             filter: blur(0px);
//           }
//         }
        
//         .modal-header {
//           background: linear-gradient(135deg, #3b82f6, #8b5cf6, #ec4899);
//           color: white;
//           padding: 2rem;
//           border-radius: 25px 25px 0 0;
//           position: relative;
//           overflow: hidden;
//         }
        
//         .modal-close {
//           position: absolute;
//           top: 1rem;
//           right: 1rem;
//           background: rgba(255, 255, 255, 0.2);
//           border: none;
//           color: white;
//           width: 40px;
//           height: 40px;
//           border-radius: 50%;
//           font-size: 1.5rem;
//           cursor: pointer;
//           transition: all 0.3s ease;
//           backdrop-filter: blur(10px);
//         }
        
//         .modal-close:hover {
//           background: rgba(255, 255, 255, 0.3);
//           transform: rotate(90deg);
//         }
        
//         .course-card {
//           transition: all 0.3s ease;
//           backdrop-filter: blur(10px);
//           background: rgba(255, 255, 255, 0.95);
//         }
        
//         .course-card:hover {
//           transform: translateY(-10px);
//           box-shadow: 0 20px 40px rgba(59, 130, 246, 0.3);
//         }
        
//         .notification {
//           position: fixed;
//           top: 20px;
//           right: 20px;
//           padding: 15px 20px;
//           border-radius: 8px;
//           color: white;
//           font-weight: bold;
//           z-index: 100001;
//           transform: translateX(400px);
//           transition: transform 0.3s ease;
//         }
        
//         .notification.show {
//           transform: translateX(0);
//         }
        
//         .notification.success {
//           background-color: #10b981;
//         }
        
//         .notification.error {
//           background-color: #ef4444;
//         }
        
//         .scroll-indicator {
//           position: fixed;
//           bottom: 30px;
//           left: 50%;
//           transform: translateX(-50%);
//           z-index: 100;
//           animation: bounce 2s infinite;
//         }
        
//         @keyframes bounce {
//           0%, 20%, 50%, 80%, 100% { transform: translateX(-50%) translateY(0); }
//           40% { transform: translateX(-50%) translateY(-10px); }
//           60% { transform: translateX(-50%) translateY(-5px); }
//         }
        
//         @keyframes scroll {
//           0% { opacity: 1; top: 8px; }
//           100% { opacity: 0; top: 20px; }
//         }
        
//         .ctrl-center {
//           animation: ctrlPulse 3s ease-in-out infinite;
//           position: relative;
//           cursor: pointer;
//           transition: all 0.3s ease;
//         }
        
//         .ctrl-center::before {
//           content: '';
//           position: absolute;
//           top: -5px;
//           left: -5px;
//           right: -5px;
//           bottom: -5px;
//           border: 2px solid rgba(59, 130, 246, 0.3);
//           border-radius: 50%;
//           animation: ctrlRipple 2s ease-out infinite;
//         }
        
//         .ctrl-center::after {
//           content: '';
//           position: absolute;
//           top: -10px;
//           left: -10px;
//           right: -10px;
//           bottom: -10px;
//           border: 1px solid rgba(255, 255, 255, 0.2);
//           border-radius: 50%;
//           animation: ctrlRipple 3s ease-out infinite;
//           animation-delay: 1s;
//         }
        
//         @keyframes ctrlPulse {
//           0%, 100% { transform: scale(1); box-shadow: 0 10px 30px rgba(0,0,0,0.3); }
//           50% { transform: scale(1.05); box-shadow: 0 15px 40px rgba(0,0,0,0.4); }
//         }
        
//         @keyframes ctrlRipple {
//           0% { transform: scale(1); opacity: 1; }
//           100% { transform: scale(2); opacity: 0; }
//         }
//       `}</style>
//     </section>
//   );
// };

// export default Services;